import React from "react";
import { useSelector } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { SecurityAccounts } from "../../models";

const getStatusLabel = (status?: SecurityAccounts) => (status ? status.accNo : "");

export const useSecurityAccountsForDefault = () => {
	const statuses = useSelector<StoreType, SecurityAccounts[]>(store => store.data.initialData.securityAccounts);

	return [statuses, getStatusLabel] as [typeof statuses, typeof getStatusLabel];
};

export const useSecurityAccountForDefault = (accUse?: string) => {
	const [secaccs] = useSecurityAccountsForDefault();

	const secacc = React.useMemo(() => secaccs.find(c => c.accUse !== "D" && c.defFor===1 ), [secaccs, accUse]);
	const secaccLabel = React.useMemo(() => getStatusLabel(secacc), [secacc]);

	return [secacc, secaccLabel] as [typeof secacc, typeof secaccLabel];
};


